const icon = require('vue-svgicon');
icon.register({
    'partner-add': {
        width: 20,
        height: 20,
        viewBox: '0 0 20 20',
        data: `<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M10.748 10.985c.914.36 1.721.928 2.373 1.64-.277.236-.53.495-.74.792-.977-1.105-2.39-1.816-3.981-1.816a5.333 5.333 0 00-5.333 5.332V18H2v-1.067a6.397 6.397 0 014.052-5.948A4.798 4.798 0 018.4 2a4.798 4.798 0 012.348 8.985zm6.719 4.88h-1.6v1.6a.533.533 0 01-1.067 0v-1.6h-1.6a.533.533 0 010-1.066h1.6v-1.6a.534.534 0 111.067 0v1.6h1.6a.534.534 0 010 1.067zM4.667 6.8a3.733 3.733 0 117.466.001 3.733 3.733 0 01-7.466 0z" _fill="#9C9BA9"/>`,
    },
});
